import { SkillAssessmentDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useUserContext } from '@/utils/providers/userContext/useUserContext.tsx';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

type Response = SkillAssessmentDto[] | undefined;

interface Return {
  error: AxiosError | null;
  isGetting: boolean;
  userSkills: Response;
}

export const useGetUserSkillsAssessment = (enabled: boolean): Return => {
  const { restSkillsApi } = useApiClient();
  const { user } = useUserContext();

  const { data, error, isLoading } = useQuery<Response, AxiosError>({
    enabled: !!user?.userId && enabled,
    queryFn: async () => {
      if (user?.userId) {
        const response = await restSkillsApi.getUserSkillsAssessment(user.userId);

        return response.data;
      }

      return undefined;
    },
    queryKey: [QueryKeyEnum.GET_USER_SKILLS_ASSESSMENT],
  });

  return { error, isGetting: isLoading, userSkills: data };
};
